module.exports = __webpack_public_path__ + "static/media/hat_c.d1d61944.ogg";